import React from 'react';
import { connect } from 'react-redux';
import { logout } from '../../data/reducers/auth';
import NavItem from './navbar.item';

const NavbarList = ({ isAuth, logout, cartItems, closeMenu }) => {

  // ✅ correct count calculation
  const cartCount = cartItems.reduce(
    (total, item) => total + item.quantity,
    0
  );

  return (
    <ul className="flex flex-col md:flex-row md:items-center gap-4 p-6 md:p-0">

      <NavItem link="/" name="Home" onClick={closeMenu} />
      <NavItem link="/shop" name="Shop" onClick={closeMenu} />
      <NavItem link="/dashboard" name="Dashboard" onClick={closeMenu} />

      {/* Auth */}
      {isAuth ? (
        <li>
          <button
            onClick={() => {
              logout();
              closeMenu && closeMenu();
            }}
            className="px-3 py-2 font-medium text-gray-700 hover:text-blue-600"
          >
            Sign out
          </button>
        </li>
      ) : (
        <>
          <NavItem link="/login" name="Login" onClick={closeMenu} />
          <NavItem link="/register" name="Register" onClick={closeMenu} />
        </>
      )}

      {/* 🛒 CART BADGE — FIXED */}
      <li>
        <NavItem link="/cart" onClick={closeMenu}>
          <div className="relative px-2 py-1 text-gray-800 hover:text-blue-600">
            <span role="img" aria-label="cart">🛒</span>

            {cartCount > 0 && (
              <span className="
                absolute -top-2 -right-2
                bg-red-500 text-white text-xs
                w-5 h-5 flex items-center justify-center
                rounded-full font-bold
              ">
                {cartCount}
              </span>
            )}
          </div>
        </NavItem>
      </li>

    </ul>
  );
};

const mapStateToProps = (state) => ({
  isAuth: state.auth.isAuthenticated,

  // ✅ CORRECT PATH
  cartItems: state.cart.cart,
});

export default connect(mapStateToProps, { logout })(NavbarList);

